import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { useLanguage } from '../i18n/LanguageContext';
import { localizeCollection } from '../i18n/localizeData';

function PrendreRendezVousPage() {
  const { professionalId } = useParams();
  const navigate = useNavigate();
  const [services, setServices] = useState([]);
  const [selectedService, setSelectedService] = useState(null);
  const { t, language } = useLanguage();

  useEffect(() => {
    axios.get(`https://1irywxa5c3.execute-api.ca-central-1.amazonaws.com/prod/professionals/${professionalId}/services`)
      .then(response => setServices(localizeCollection(response.data, language)))
      .catch(error => console.error('Erreur fetching services:', error));
  }, [language, professionalId]);

  const handleNext = () => {
    if (selectedService) {
      navigate(`/disponibilites/${professionalId}`, {
        state: { serviceId: selectedService }
      });
    } else {
      alert(t('booking.missingService'));
    }
  };

  return (
    <div style={{ padding: '40px 20px', maxWidth: '1200px', margin: '0 auto' }}>
      
      {/* Titre principal */}
      <h2 style={{
        textAlign: 'center',
        fontSize: '32px',
        marginBottom: '40px',
        color: '#2c2c2c',
        fontWeight: 600
      }}>
        {t('booking.chooseService')}
      </h2>

      {/* Cartes services */}
      <div
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          gap: '20px',
          justifyContent: 'center'
        }}
      >
        {services.map(service => (
          <div
            key={service.service_id}
            onClick={() => setSelectedService(service.service_id)}
            style={{
              border: selectedService === service.service_id ? '2px solid #6A1B9A' : '1px solid #e0e0e0',
              borderRadius: '10px',
              padding: '24px',
              cursor: 'pointer',
              width: '280px',
              minHeight: '150px',
              backgroundColor: selectedService === service.service_id ? '#f5eafc' : '#fff',
              boxShadow: selectedService === service.service_id ? '0 4px 12px rgba(106,27,154,0.2)' : '0 2px 8px rgba(0,0,0,0.05)',
              transition: 'all 0.25s ease-in-out',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between'
            }}
          >
            <div>
              <h4 style={{ fontSize: '20px', marginBottom: '12px', color: '#333' }}>{service.name}</h4>
              <p style={{ color: '#555', fontSize: '15px' }}>{service.description}</p>
            </div>
          </div>
        ))}
      </div>

      {/* Bouton valider */}
      <div style={{ textAlign: 'center', marginTop: '50px' }}>
        <button
          onClick={handleNext}
          disabled={!selectedService}
          style={{
            backgroundColor: selectedService ? '#6A1B9A' : '#ccc',
            color: '#fff',
            border: 'none',
            padding: '14px 32px',
            fontSize: '16px',
            borderRadius: '8px',
            cursor: selectedService ? 'pointer' : 'not-allowed',
            fontWeight: '600',
            transition: 'background-color 0.2s ease-in-out'
          }}
        >
          {t('booking.viewAvailability')}
        </button>
      </div>
    </div>
  );
}

export default PrendreRendezVousPage;
